import React from 'react';
import { Button } from './Button';
import { CountdownTimer } from './CountdownTimer';
export function PurchaseSection() {
  return <section id="compra" className="py-8 md:py-12 px-4 bg-brand-card scroll-mt-10" data-id="element-208">
      <div className="max-w-4xl mx-auto" data-id="element-209">
        <div className="text-center mb-8" data-id="element-210">
          <div className="inline-block bg-brand-accent/20 text-brand-accent font-bold px-4 py-1.5 rounded-full mb-4 border border-brand-accent/30 animate-pulse text-sm" data-id="element-211">
            ⏰ EL PRECIO DE LANZAMIENTO TERMINA EN:
          </div>

          <div className="mb-4" data-id="element-212">
            <CountdownTimer data-id="element-213" />
          </div>

          <p className="text-sm md:text-base font-medium text-gray-400 mb-4" data-id="element-214">
            Después sube el precio y no vuelve a bajar.
          </p>

          <div className="max-w-sm mx-auto bg-brand-dark p-3 rounded-lg border border-white/10" data-id="element-215">
            <div className="flex justify-between text-xs font-bold mb-1.5" data-id="element-216">
              <span className="flex items-center text-red-500" data-id="element-217">
                <span className="w-1.5 h-1.5 rounded-full bg-red-500 mr-1.5 animate-ping" data-id="element-218"></span>
                🔴 Cupos al precio de lanzamiento
              </span>
              <span className="text-gray-400" data-id="element-219">Quedan pocos</span>
            </div>
            <div className="w-full bg-gray-800 rounded-full h-2 mb-1 overflow-hidden" data-id="element-220">
              <div className="bg-red-500 h-2 rounded-full w-[78%]" data-id="element-221"></div>
            </div>
            <p className="text-[10px] text-gray-600 text-right" data-id="element-222">
              78% de los cupos tomados
            </p>
          </div>
        </div>

        <h2 className="text-2xl md:text-4xl font-black text-center mb-8 text-white" data-id="element-223">
          💰 ELEGÍ TU KIT
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-3xl mx-auto" data-id="element-224">
          <div className="bg-brand-dark rounded-xl border border-white/10 p-5 md:p-6 flex flex-col relative" data-id="element-225">
            <div className="mb-4" data-id="element-226">
              <h3 className="text-xl font-black text-white mb-1 flex items-center" data-id="element-227">
                <span className="text-2xl mr-2" data-id="element-228">📘</span> KIT INSTALACIONES
                ELÉCTRICAS LISTAS
              </h3>
              <p className="text-brand-accent font-bold text-sm" data-id="element-229">
                6 Tomos + 4 Bonos
              </p>
            </div>

            <div className="bg-brand-card p-3 rounded-lg mb-6 border border-white/5" data-id="element-230">
              <p className="text-xs text-gray-400 font-medium" data-id="element-231">
                <span className="font-bold text-gray-200" data-id="element-232">Ideal para:</span>{' '}
                docentes de electrotecnia y maestros de taller
              </p>
            </div>

            <div className="mb-6 flex-grow" data-id="element-233">
              <div className="flex items-end justify-center mb-1" data-id="element-234">
                <span className="text-lg text-gray-600 line-through font-medium mr-2" data-id="element-235">
                  $45.000
                </span>
                <span className="text-3xl md:text-4xl font-black text-white" data-id="element-236">
                  $19.990{' '}
                  <span className="text-lg text-gray-500 font-medium" data-id="element-237">ARS</span>
                </span>
              </div>
            </div>

            <Button href="https://checkout.kitonline.shop/cart/47928490459374:1" className="py-3 text-sm md:text-base" pulse={false} data-id="element-238">
              → QUIERO MI KIT AHORA
            </Button>
          </div>

          <div className="bg-brand-dark rounded-xl border-2 border-brand-accent p-5 md:p-6 flex flex-col relative transform md:-translate-y-2 shadow-[0_0_20px_rgba(14,165,233,0.15)]" data-id="element-239">
            <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-brand-accent text-white font-black px-4 py-1 rounded-full text-xs tracking-wider shadow-sm whitespace-nowrap" data-id="element-240">
              MÁS ELEGIDO ⭐
            </div>

            <div className="mb-4 mt-2" data-id="element-241">
              <h3 className="text-xl font-black text-white mb-1 flex items-center" data-id="element-242">
                <span className="text-2xl mr-2" data-id="element-243">🏆</span> KIT + PROYECTOS
                INTEGRADORES ELÉCTRICOS ⭐
              </h3>
              <p className="text-brand-accent font-bold text-sm" data-id="element-244">
                6 Tomos + 4 Bonos + Upsell
              </p>
            </div>

            <div className="bg-brand-accent/10 p-3 rounded-lg mb-6 border border-brand-accent/20" data-id="element-245">
              <p className="text-xs text-gray-300 font-medium" data-id="element-246">
                <span className="font-bold text-white" data-id="element-247">Ideal para:</span>{' '}
                docentes que quieren cerrar el año con proyectos reales de alto
                impacto
              </p>
            </div>

            <div className="mb-6 flex-grow" data-id="element-248">
              <div className="flex items-end justify-center mb-1" data-id="element-249">
                <span className="text-lg text-gray-600 line-through font-medium mr-2" data-id="element-250">
                  $63.000
                </span>
                <span className="text-3xl md:text-4xl font-black text-brand-accent neon-glow" data-id="element-251">
                  $27.990{' '}
                  <span className="text-lg text-gray-500 font-medium" data-id="element-252">ARS</span>
                </span>
              </div>
            </div>

            <Button href="https://checkout.kitonline.shop/cart/47928490754286:1" className="py-3 md:py-4 text-base md:text-lg" pulse={true} data-id="element-253">
              → QUIERO EL KIT COMPLETO
            </Button>
          </div>
        </div>
      </div>
    </section>;
}